var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase */
import Vue from 'vue';
import rpc from '../../api/rpc';
import createRecords from 'src/utils/entityOperations/createRecords';
import { getSonarFileImageSize } from 'src/store/files/files';
import { invokeOrFalse } from 'src/utils';
import { get } from 'lodash';
const fileUploaderPropsRunTimeChecker = (propsToCheck) => {
    const errors = [];
    let destination = propsToCheck.destination;
    if (!destination) {
        errors.push('Destination is missing');
    }
    if (!destination)
        destination = {};
    if (!destination.destination_type && !destination.bucket && destination.region && destination.provider) {
        errors.push('detination_type and bucket/region/provider cannot be both NULL');
    }
    if (destination.destination_type && (destination.bucket || destination.region || destination.provider)) {
        errors.push('detination_type and bucket/region/provider cannot be both NOT NULL');
    }
    if (!destination.destination_type && (destination.bucket || destination.region || destination.provider)) {
        if (!destination.bucket || !destination.region || !destination.provider) {
            errors.push('If at least one of bucket/region/provider is entered then all of them must be entered');
        }
    }
    if (errors.length > 0)
        console.error(errors);
    return {
        status: errors.length > 0 ? 'error' : 'ok',
        errors
    };
};
export default Vue.extend({
    props: {
        requestedVersionsToCreate: { type: Array },
        onlyAllowSingleFile: { type: Boolean },
        qFileProps: { type: Object },
        destination: { type: Object }
    },
    data() {
        return {
            fileRecords: {},
            urls: [],
            isUploading: false
        };
    },
    computed: {
        canUpload() { return Object.keys(this.fileRecords).length > 0; }
    },
    watch: {
        '$props': {
            immediate: true,
            handler(newVal) {
                fileUploaderPropsRunTimeChecker(newVal);
            }
        }
    },
    methods: {
        getProgressPercent(file) { var _a; return ((_a = this.fileRecords[file.name].progress) === null || _a === void 0 ? void 0 : _a.percent) || 0; },
        // @ts-ignore
        getProgressStatus(file) { return get(this.fileRecords[file.name], 'progress.status'); },
        getStatusColor(file) { return { error: 'red-2', ok: 'green-3', cancelled: 'orange-2', '0': 'orange-2' }[this.getProgressStatus(file)]; },
        // @ts-ignore
        getProgressIcon(file) { return get(this.fileRecords[file.name], 'progress.icon'); },
        removeFile(name) { this.$set(this.fileRecords, `${name}.progress.status`, 'cancelled'); },
        handleFileInput(inputFiles) {
            if (!Array.isArray(inputFiles) && inputFiles) { // this handles when only single file is allowed in q-file component
                inputFiles = [inputFiles];
            }
            if (!inputFiles)
                inputFiles = [];
            this.fileRecords = {}; // the key is file name and the value is a File object
            inputFiles.forEach(file => {
                const icon = file.type.indexOf('video/') === 0
                    ? 'movie'
                    : (file.type.indexOf('image/') === 0
                        ? 'photo'
                        : (file.type.indexOf('audio/') === 0
                            ? 'audiotrack'
                            : 'insert_drive_file'));
                const progress = {
                    name: file.name,
                    status: 'ok',
                    percent: 0,
                    icon: icon,
                    request: null,
                    uuid: undefined
                };
                this.$set(this.fileRecords, file.name, { file, progress });
            });
        },
        createFileVersions(key, bucket) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.requestedVersionsToCreate || ((_a = this.requestedVersionsToCreate) === null || _a === void 0 ? void 0 : _a.length) === 0)
                    return;
                const versions = {};
                for (const requestedVersion of this.requestedVersionsToCreate || []) {
                    const size = getSonarFileImageSize(requestedVersion);
                    versions[requestedVersion] = [size, size];
                }
                const response = yield this.$http.post('https://g7sts4jn75.execute-api.us-east-1.amazonaws.com/default/image-resizer', { key, bucket, versions });
                return response.data;
            });
        },
        upload() {
            // handle previously cancelled uploads
            for (const name in this.fileRecords) {
                if (this.$set(this.fileRecords[name], 'progress.status', 'cancelled')) {
                    this.$set(this.fileRecords[name], 'progress.status', 'ok');
                }
            }
            const files = [];
            for (const fileName in this.fileRecords) {
                const fileRecord = this.fileRecords[fileName];
                if (!fileRecord)
                    continue;
                files.push({ file_name: fileName, file: fileRecord.file });
            }
            rpc('files.get_aws_presigned_urls', { destination: this.destination, file_names: files.map(f => f.file_name), expires_in: 3600 })
                .then((preassignedUrlObject) => {
                const fileUrlInfos = preassignedUrlObject.files;
                files.forEach(file => {
                    var _a;
                    file.uuid_name = (_a = fileUrlInfos.find(fui => fui.file_name === file.file_name)) === null || _a === void 0 ? void 0 : _a.uuid_name;
                });
                this.isUploading = true;
                Promise.all(fileUrlInfos.map(fileUrlInfo => {
                    const fileRec = files.find(f => f.file_name === fileUrlInfo.file_name);
                    const file = fileRec === null || fileRec === void 0 ? void 0 : fileRec.file;
                    if (!file)
                        return;
                    const headers = {
                        'Content-Type': file.type,
                        'Content-Disposition': `inline; filename=${file.name}` // use 'attachment' to force file download, 'inline' lets browser to try to open the file
                    };
                    return this.$http.put(fileUrlInfo.links.put, file, {
                        headers,
                        before: (request) => {
                            // store request object and assign uuid
                            this.fileRecords[file.name].progress = Object.assign(Object.assign({}, this.fileRecords[file.name].progress), { request, uuid: fileUrlInfo.uuid_name });
                        },
                        uploadProgress: (e) => {
                            var _a, _b, _c, _d, _e;
                            // abort request on error, i.e. when user cancels upload
                            if (((_b = (_a = this.fileRecords[file.name]) === null || _a === void 0 ? void 0 : _a.progress) === null || _b === void 0 ? void 0 : _b.status) !== 'ok')
                                invokeOrFalse((_e = (_d = (_c = this.fileRecords[fileUrlInfo.file_name]) === null || _c === void 0 ? void 0 : _c.progress) === null || _d === void 0 ? void 0 : _d.request) === null || _e === void 0 ? void 0 : _e.abort);
                            const percent = e.loaded / e.total;
                            if (this.fileRecords[file.name].progress === undefined)
                                this.$set(this.fileRecords[file.name], 'progress', { 'percent': 0 });
                            // @ts-ignore
                            this.$set(this.fileRecords[file.name].progress, 'percent', percent || 0);
                        }
                    })
                        // @ts-ignore
                        .catch((e) => {
                        // check if request was not aborted by user (e.status === 0)
                        if (e.status > 0) { // server error
                            this.$set(this.fileRecords[fileUrlInfo.file_name], 'progress.status', 'error');
                        }
                    });
                })).then(responses => {
                    // get UUIDs of successfully uploaded files (status === 200 or resp.ok === true)
                    const successfullyUploaded = responses.filter((resp) => resp && resp.ok).map((resp) => (new URL(resp.url)).pathname.slice(1));
                    const successfullyUploadedFiles = files.filter(file => successfullyUploaded.includes(file.uuid_name || '-1'));
                    Promise
                        .all(successfullyUploadedFiles.map(file => this.createFileVersions(file.uuid_name, preassignedUrlObject.destination.bucket)))
                        .then(resizerResponses => {
                        resizerResponses.forEach(resizerResponse => {
                            if (resizerResponse) {
                                const suf = successfullyUploadedFiles.find(f => f.uuid_name === resizerResponse.key);
                                if (suf)
                                    suf.versions = resizerResponse.versions;
                            }
                        });
                        // save uploaded file info to DB
                        const records = successfullyUploadedFiles
                            .map(file => {
                            return {
                                key: file.uuid_name,
                                file_name: file.file_name,
                                bucket: preassignedUrlObject.destination.bucket,
                                region: preassignedUrlObject.destination.region,
                                provider: preassignedUrlObject.destination.provider,
                                name: file.file_name,
                                description: undefined,
                                versions: Object.keys((file === null || file === void 0 ? void 0 : file.versions) || {})
                                    .map((versionType) => {
                                    var _a, _b;
                                    return { version_type: versionType, key: (_b = (_a = file.versions) === null || _a === void 0 ? void 0 : _a[versionType]) === null || _b === void 0 ? void 0 : _b.key };
                                })
                            };
                        });
                        createRecords('files.files', records)
                            .then(() => {
                            this.$emit('upload-success', records);
                            this.isUploading = false;
                            this.fileRecords = {};
                        });
                    });
                });
            });
        }
    }
});
